import React, { useState } from "react";
import {
  Container,
  Button,
  TextField,
  Typography,
  Box,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Snackbar,
  Alert,
  Grid,
  Card,
  CardContent,
} from "@mui/material";
import axios from "axios";

function Settings() {
  const [versionHistoryData, setVersionHistoryData] = useState([]);
  const [apkManagerData, setApkManagerData] = useState([]);
  const [versionForm, setVersionForm] = useState({
    version: "",
    anyLink: "",
    comment: "",
    editBy: "",
  });
  const [apkForm, setApkForm] = useState({
    examName: "",
    performance: "",
    apkLink: "",
    comment: "",
  });
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [showApkManager, setShowApkManager] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [responseType, setResponseType] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const getCurrentDateTime = () => {
    const now = new Date();
    return {
      date: now.toISOString().split("T")[0],
      time: now.toTimeString().split(" ")[0],
    };
  };

  const handleVersionSubmit = async () => {
  const { version, anyLink, comment, editBy } = versionForm;
  if (!version || !anyLink || !comment || !editBy) {
    setResponseMessage("Please fill all fields before submitting.");
    setResponseType("error");
    setOpenSnackbar(true);
    return;
  }

  const { date, time } = getCurrentDateTime();
  const newVersion = { ...versionForm, date, time };

  try {
    await axios.post("https://croireatpl.in/api/version-history", newVersion);
    setResponseMessage("Version history added successfully!");
    setResponseType("success");
    setVersionForm({ version: "", anyLink: "", comment: "", editBy: "" });
  } catch (error) {
    setResponseMessage(error.response?.data || "Error adding version history");
    setResponseType("error");
  } finally {
    setOpenSnackbar(true);
  }
};


  const handleVersionGet = async () => {
    try {
      const response = await axios.get("https://croireatpl.in/api/version-history");
      setVersionHistoryData(response.data);
    } catch (error) {
      console.error("Error fetching version history", error);
    }
  };

  const handleApkSubmit = async () => {
  const { examName, performance, apkLink, comment } = apkForm;
  if (!examName || !performance || !apkLink || !comment) {
    setResponseMessage("Please fill all fields before submitting.");
    setResponseType("error");
    setOpenSnackbar(true);
    return;
  }

  const { date, time } = getCurrentDateTime();
  const newApk = { ...apkForm, date, time };

  try {
    const response = await axios.post("https://croireatpl.in/api/apk-manager", newApk);
    setResponseMessage(`APK entry added successfully! ID: ${response.data.id}`);
    setResponseType("success");
    setApkForm({ examName: "", performance: "", apkLink: "", comment: "" });
  } catch (error) {
    setResponseMessage(error.response?.data || "Error adding APK entry");
    setResponseType("error");
  } finally {
    setOpenSnackbar(true);
  }
};


  const handleApkGet = async () => {
    try {
      const response = await axios.get("https://croireatpl.in/api/apk-manager");
      setApkManagerData(response.data);
    } catch (error) {
      console.error("Error fetching APK manager data", error);
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" gutterBottom>
        Settings Panel
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Button fullWidth variant="contained" onClick={() => setShowVersionHistory(true)}>
            Version History
          </Button>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Button fullWidth variant="contained" onClick={() => setShowApkManager(true)}>
            APK Manager
          </Button>
        </Grid>
      </Grid>

      {showVersionHistory && (
        <Card sx={{ mt: 4 }}>
          <CardContent>
            <Typography variant="h6">Add Version History</Typography>
            <Grid container spacing={2} mt={1}>
              {["Version", "Any Link", "Comment", "Edited By"].map((label, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    label={label}
                    value={versionForm[label.toLowerCase().replace(/\s/g, "")]}
                    onChange={(e) =>
                      setVersionForm({
                        ...versionForm,
                        [label.toLowerCase().replace(/\s/g, "")]: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </Grid>
              ))}
              <Grid item xs={12} sm={6}>
                <Button variant="contained" fullWidth onClick={handleVersionSubmit}>
                  Submit Version
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button variant="outlined" fullWidth onClick={handleVersionGet}>
                  Fetch Versions
                </Button>
              </Grid>
            </Grid>

            <TableContainer sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Version</TableCell>
                    <TableCell>Link</TableCell>
                    <TableCell>Comment</TableCell>
                    <TableCell>Edit By</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {versionHistoryData.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>{entry.date}</TableCell>
                      <TableCell>{entry.version}</TableCell>
                      <TableCell>{entry.anyLink}</TableCell>
                      <TableCell>{entry.comment}</TableCell>
                      <TableCell>{entry.editBy}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      {showApkManager && (
        <Card sx={{ mt: 4 }}>
          <CardContent>
            <Typography variant="h6">Add APK Entry</Typography>
            <Grid container spacing={2} mt={1}>
              {["Exam Name", "Performance", "APK Link", "Comment"].map((label, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    label={label}
                    value={apkForm[label.toLowerCase().replace(/\s/g, "")]}
                    onChange={(e) =>
                      setApkForm({
                        ...apkForm,
                        [label.toLowerCase().replace(/\s/g, "")]: e.target.value,
                      })
                    }
                    fullWidth
                  />
                </Grid>
              ))}
              <Grid item xs={12} sm={6}>
                <Button variant="contained" fullWidth onClick={handleApkSubmit}>
                  Submit APK
                </Button>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Button variant="outlined" fullWidth onClick={handleApkGet}>
                  Fetch APKs
                </Button>
              </Grid>
            </Grid>

            <TableContainer sx={{ mt: 3 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Exam Name</TableCell>
                    <TableCell>Performance</TableCell>
                    <TableCell>APK Link</TableCell>
                    <TableCell>Comment</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {apkManagerData.map((entry, index) => (
                    <TableRow key={index}>
                      <TableCell>{entry.date}</TableCell>
                      <TableCell>{entry.examName}</TableCell>
                      <TableCell>{entry.performance}</TableCell>
                      <TableCell>{entry.apkLink}</TableCell>
                      <TableCell>{entry.comment}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      )}

      <Snackbar open={openSnackbar} autoHideDuration={6000} onClose={() => setOpenSnackbar(false)}>
        <Alert severity={responseType} onClose={() => setOpenSnackbar(false)}>
          {responseMessage}
        </Alert>
      </Snackbar>
    </Container>
  );
}

export default Settings;
